import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Revenue from "@/pages/Revenue";
import Expenses from "@/pages/Expenses";
import Allocation from "@/pages/Allocation";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

const Shell = ({ children }) => (
  <ProtectedRoute>
    <AppProvider>
      <Layout>{children}</Layout>
    </AppProvider>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/revenue" element={<Shell><Revenue /></Shell>} />
            <Route path="/expenses" element={<Shell><Expenses /></Shell>} />
            <Route path="/allocation" element={<Shell><Allocation /></Shell>} />
            <Route path="/reports" element={<Shell><Reports /></Shell>} />
            <Route path="/settings" element={<Shell><Settings /></Shell>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
